module.exports = __webpack_public_path__ + "5dfc548cc3b2c411dcc120a592c21063.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/12_column_small_x1/public/news/img1_2.jpg
// module id = 326
// module chunks = 0